import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  Stack,
  Select,
  DialogActions,
  DialogTitle,
  Card,
  CardContent,
  AppBar,
  Toolbar,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";
import { departmentHRApi, DepartmentApis } from "../../../Data/axios";

import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import { useSelector } from "react-redux";
// import HeaderDepartment from "./HeaderDepartment";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function Department() {
  const [open, setOpen] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [name, setName] = React.useState("");
  const userPermissions = useSelector((state) => state?.user?.permissions);
  const [parent, setParent] = React.useState("");

  const [updateName, setUpdateName] = React.useState("");
  const [updateParentDepartment, setUpdateParentDepartment] =
    React.useState("");
  const [parentValue, setParentValue] = useState([]);
  const [data, SetData] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [update, setUpdate] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");

  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleClickUpdate = () => {
    setUpdate(true);
  };

  const handleUpdateClose = () => {
    setUpdate(false);
    setUpdateName("");
    setUpdateParentDepartment("");
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setName("");
    setParent("");
  };

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    try {
      const response = await departmentHRApi.getAll();
      // const { data, pagination } = response;
    if (response && response.data) {
      setDesignationData(response.data);
    } else {
      setDesignationData([]);
      showAlert("No departments found or empty response", "info");
    }
  } catch (error) {
    console.error("Error fetching department data:", error);
    const errorMessage = error.response?.data?.message || error.message || "Unknown error";
    showAlert(`Failed to load departments: ${errorMessage}`, "error");
  }
}
  
  useEffect(() => {
    const fetchParentValues = async () => {
      try {
        // Use the correct API method from the correct API object
        const response = await DepartmentApis.getParentValue();
        
        if (response) {
          setParentValue(response);
          console.log("Parent departments loaded:", response);
        } else {
          console.error("No parent departments found");
          setParentValue([]);
        }
      } catch (error) {
        console.error("Error fetching parent departments:", error);
        showAlert("Failed to load parent department options", "error");
        setParentValue([]);
      }
    };

    fetchParentValues();
  }, []);
  
  const columns = [
    {
      name: "department",
      label: "Department",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Department
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "parent",
      label: "Parent Department",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center", // Aligns header to the left
                // Add padding for starting point
                borderBottom: "1px solid #ddd",
              }}
            >
              Parent Department
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center", // Aligns content to the left
                alignItems: "center",
                // Add padding for starting point
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Actions",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right", // Aligns header to the left
                paddingRight: "70px", // Add padding for starting point
                borderBottom: "1px solid #ddd",
              }}
            >
              Actions
            </th>
          );
        },
        customBodyRender: (value) => (
          <div
            key={value}
            style={{
              display: "flex",
              justifyContent: "flex-end", // Aligns content to the left
              alignItems: "center",
              paddingLeft: "20px", // Add padding for starting point
            }}
          >
            <Stack
              spacing={2}
              direction="row"
              sx={{
                justifyContent: "flex-end",
                "& .MuiButton-root": {
                  margin: "0 4px",
                },
              }}
            >
              {userPermissions?.hr_department_update !== 0 && (
                <Button variant="outlined" onClick={() => handleEdit(value)}>
                  <EditNoteIcon /> Update
                </Button>
              )}
              {userPermissions?.hr_department_delete !== 0 && (
                <Button variant="outlined" onClick={() => handleDelete(value)}>
                  <DeleteForeverIcon /> Delete
                </Button>
              )}
            </Stack>
          </div>
        ),
      },
    },
  ];
  async function handleEdit(id) {
    const result = designationData.filter((item) => item.id === id);

    SetData(result[0]);

    handleClickUpdate();
  }
  useEffect(() => {
    setUpdateName(data.department);
  }, [data.department]);

  useEffect(() => {
    setUpdateParentDepartment(data.parent);
  }, [data.parent]);

  async function updateDepartment() {
    const formData = new FormData();

    formData.append("department", updateName);
    formData.append("parent", updateParentDepartment);

    try {
      await departmentHRApi.update(data.id, formData);

      handleUpdateClose();

      getData();
      setName("");
      setParent("");
      showAlert("  Updated successfully", "success");
    } catch (error) {
      console.error(error);
      showAlert("Failed to update", "error");
    }
  }

  async function handleDelete(id) {
    try {
      // Use the API's delete method with the correct method name
      await departmentHRApi.delete(id);
      getData();
      showAlert(" Deleted Successfully!", "warning");
    } catch (error) {
      console.error("Error deleting department:", error);
      showAlert("Error deleting department: " + error.message, "error");
    }
  }

  async function AddDepartment() {
    const formData = new FormData();

    // const creator_name = localStorage.getItem("empid");
    formData.append("department", name);
    formData.append("parent", parent);
    // formData.append("creator_id", creator_name);

    await departmentHRApi.add(formData);

    showAlert(" Added successfully", "success");

    getData();
    handleClose();
  }

  const options = {
    selectableRows: "none",
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 25, 50, 100],
    tableBody: {
      style: {
        maxHeight: "500px",
        overflowY: "scroll",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
        fontWeight: 600,
        justifyContent: "flex-start", // Aligns header items to the left
      },
    },
    rows: {
      style: {
        marginLeft: "5px",
        textAlign: "start", // Aligns row items to the left
      },
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  // Define reusable input styling to match RecJobs style
  const inputProps = {
    sx: {
      bgcolor: "#f9f9f9",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#e0e0e0",
        },
        "&:hover fieldset": {
          borderColor: "#bdbdbd",
        },
      },
      "& .MuiSelect-select": {
        color: "#424242", // For dropdown selects
      },
      "& .MuiInputBase-input": {
        color: "#424242", // For text and date inputs
      },
    },
  };

  return (
    <>
      {/* <HeaderDepartment /> */}
      <React.Fragment>
        <Dialog
          fullWidth
          maxWidth="md"
          open={update}
          onClose={handleUpdateClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              position: "absolute",
              top: 0,
              right: 0,
              width: "calc(100% - 260px)", // Adjusted width to account for sidebar
              height: "100%",
              backgroundColor: "#f5f5f5",
              margin: 0,
              maxHeight: "100%",
              borderRadius: 0,
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <AppBar sx={{ position: "relative", bgcolor: "#ffffff", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleUpdateClose}
                aria-label="close"
                sx={{ color: "#212121" }}
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: "#212121" }} component="div">
                Update Department
              </Typography>
            </Toolbar>
          </AppBar>
          <Box sx={{ background: "#f5f5f5", p: 4, overflowY: "auto" }}>
            <Card sx={{ p: 2, bgcolor: "#ffffff", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)" }}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Name <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Department Name"
                      size="small"
                      value={updateName}
                      onChange={(e) => setUpdateName(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                      Parent Department
                    </Typography>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      value={updateParentDepartment}
                      onChange={(e) => setUpdateParentDepartment(e.target.value)}
                      InputProps={inputProps}
                    >
                      <MenuItem value="">
                        <em>---</em>
                      </MenuItem>
                      {parentValue.map((option) => (
                        <MenuItem
                          key={option.department}
                          value={option.department}
                        >
                          {option.department}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>

                <Box display="flex" gap={2} mt={3}>
                  <Button
                    onClick={updateDepartment}
                    variant="contained"
                    sx={{
                      bgcolor: "#4285F4",
                      color: "white",
                      "&:hover": { bgcolor: "#3367D6" },
                      fontWeight: 500,
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Update
                  </Button>
                  <Button
                    onClick={handleUpdateClose}
                    variant="outlined"
                    sx={{
                      borderColor: "#bdbdbd",
                      color: "#424242",
                      "&:hover": {
                        borderColor: "#9e9e9e",
                        bgcolor: "rgba(0, 0, 0, 0.04)",
                      },
                      textTransform: "none",
                      padding: "8px 16px",
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </Dialog>
      </React.Fragment>
      <List style={{ background: "none", padding: 5 }}>
        <StatusAlert
          open={alertOpen}
          setOpen={setAlertOpen}
          message={alertMessage}
          severity={alertSeverity}
        />
        <ListItemText style={{ background: "none", margin: "5px 0 5px 0px" }}>
          <React.Fragment>
            {userPermissions?.hr_department_add !== 0 && (
              <Stack direction="row" spacing={2}>
                <Box
                  onClick={handleClickOpen}
                  sx={{
                    backgroundColor: "#4285F4",
                    "&:hover": { backgroundColor: "#3367D6" },
                    textAlign: "center",
                    padding: "10px",
                    marginLeft: "10px",
                    height: "40px",
                    width: "155px",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    borderRadius: "4px",
                    fontSize: "15px",
                    fontFamily: "sans-serif",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  <AddIcon />
                  Add Department
                </Box>
              </Stack>
            )}
            <Dialog
              fullWidth
              maxWidth="md"
              open={open}
              onClose={handleClose}
              TransitionComponent={Transition}
              PaperProps={{
                style: {
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "calc(100% - 260px)", // Adjusted width to account for sidebar
                  height: "100%",
                  backgroundColor: "#f5f5f5",
                  margin: 0,
                  maxHeight: "100%",
                  borderRadius: 0,
                  overflowX: "hidden",
                  zIndex: 1200,
                },
              }}
            >
              <AppBar sx={{ position: "relative", bgcolor: "#ffffff", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                    sx={{ color: "#212121" }}
                  >
                    <CloseIcon fontSize="large" />
                  </IconButton>
                  <Typography
                    sx={{ ml: 2, flex: 1, fontSize: "18px", color: "#212121" }}
                    component="div"
                  >
                    New Department
                  </Typography>
                </Toolbar>
              </AppBar>
              <Box sx={{ background: "#f5f5f5", p: 4, overflowY: "auto" }}>
                <Card sx={{ p: 2, bgcolor: "#ffffff", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)" }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ color: "#212121", mb: 3 }}>
                      Add Department
                    </Typography>
                    <Divider sx={{ mb: 3 }} />
                    
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                          Name <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          placeholder="Department Name"
                          size="small"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          InputProps={inputProps}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                          Parent Department
                        </Typography>
                        <TextField
                          select
                          fullWidth
                          size="small"
                          value={parent}
                          onChange={(e) => setParent(e.target.value)}
                          InputProps={inputProps}
                        >
                          <MenuItem value="">
                            <em>---</em>
                          </MenuItem>
                          {parentValue.map((option) => (
                            <MenuItem
                              key={option.department}
                              value={option.department}
                            >
                              {option.department}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>

                    <Box display="flex" gap={2} mt={3}>
                      <Button
                        onClick={AddDepartment}
                        variant="contained"
                        sx={{
                          bgcolor: "#4285F4",
                          color: "white",
                          "&:hover": { bgcolor: "#3367D6" },
                          fontWeight: 500,
                          textTransform: "none",
                          padding: "8px 16px",
                        }}
                      >
                        Add
                      </Button>
                      <Button
                        onClick={handleClose}
                        variant="outlined"
                        sx={{
                          borderColor: "#bdbdbd",
                          color: "#424242",
                          "&:hover": {
                            borderColor: "#9e9e9e",
                            bgcolor: "rgba(0, 0, 0, 0.04)",
                          },
                          textTransform: "none",
                          padding: "8px 16px",
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            </Dialog>
          </React.Fragment>
        </ListItemText>
        
        <Divider />
        <ListItemText style={{ background: "white", margin: 0, width: "100%" }}>
          <ThemeProvider theme={getTheme()}>
            <MUIDataTable
              title={
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    color: "#333",
                  }}
                >
                  Departments
                </span>
              }
              data={designationData}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

export default Department;
